import React, { useState, useEffect } from 'react';
import PageContainer from '../components/containers/PageContainer';
import { Box, Button, IconButton, MenuItem, Select, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import api from '../config/axios';
import { toast } from 'react-toastify';
import Field from '../components/ui/Field';
import CustomTable from '../components/ui/CustomTable';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import MoneyOffCsredOutlinedIcon from '@mui/icons-material/MoneyOffCsredOutlined';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LocalPoliceOutlinedIcon from '@mui/icons-material/LocalPoliceOutlined';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import DownloadIcon from '@mui/icons-material/Download';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { Stack } from '@mui/system';
import CircularProgress from '@mui/material/CircularProgress';
import ModalContainer from '../components/containers/ModalContainer';
import StatusComp from '../components/common/StatusComp';
import { Link, useSearchParams } from 'react-router-dom';
import env from '../config/env';
import { Checkbox, FormControlLabel, TextField } from '@mui/material';

const Users = () => {
    const [users, setUsers] = useState([]);
    const [user, setUser] = useState('');
    const [loader, setLoader] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [totalPages, setTotalPages] = useState(0);
    // States for filters
    const [filter, setFilter] = useState(searchParams.get('status') || 'All');
    const [sort, setSort] = useState(searchParams.get('sort') || 'asc');
    const [page, setPage] = useState(parseInt(searchParams.get('page') || '1', 10));
    const [limit, setLimit] = useState(parseInt(searchParams.get('limit') || '10', 10));
    const [search, setSearch] = useState(searchParams.get('search') || '');

    const [showAddBalance, setShowAddBalance] = useState(false);
    const onCloseAddBalanceModal = () => {
        setShowAddBalance(false);
    };
    const onOpenAddBalanceModal = () => setShowAddBalance(true);

    const [showRemoveBalance, setShowRemoveBalance] = useState(false);
    const onCloseRemoveBalanceModal = () => {
        setShowRemoveBalance(false);
    };
    const onOpenRemoveBalanceModal = () => setShowRemoveBalance(true);

    const [showDeleteuser, setShowDeleteuser] = useState(false);
    const onCloseDeleteuserModal = () => {
        setShowDeleteuser(false);
    };
    const onOpenDeleteuserModal = () => setShowDeleteuser(true);

    const [showUser, setShowUser] = useState(false);
    const onCloseUserModal = () => {
        setShowUser(false);
    };
    const onOpenUserModal = () => setShowUser(true);

    const [addUser, setAddUser] = useState(false);
    const onCloseUserAddModal = () => {
        setAddUser(false);
    };
    const onOpenUserAddModal = () => setAddUser(true);

    // Download All Users Tracking Modal
    const [showDownloadAllTrackings, setShowDownloadAllTrackings] = useState(false);
    const [downloadAllFromDate, setDownloadAllFromDate] = useState('');
    const [downloadAllToDate, setDownloadAllToDate] = useState('');
    const [downloadAllIncludeLabelType, setDownloadAllIncludeLabelType] = useState(false);
    const [downloadingAllDateRange, setDownloadingAllDateRange] = useState(false);
    const [downloadingAllTrackings, setDownloadingAllTrackings] = useState(false);
    const onCloseDownloadAllTrackingsModal = () => {
        setShowDownloadAllTrackings(false);
        setDownloadAllFromDate('');
        setDownloadAllToDate('');
        setDownloadAllIncludeLabelType(false);
    };
    const onOpenDownloadAllTrackingsModal = () => setShowDownloadAllTrackings(true);

    // Download User Date Range Tracking Modal
    const [showDownloadUserDateRange, setShowDownloadUserDateRange] = useState(false);
    const [downloadUserFromDate, setDownloadUserFromDate] = useState('');
    const [downloadUserToDate, setDownloadUserToDate] = useState('');
    const [downloadUserIncludeLabelType, setDownloadUserIncludeLabelType] = useState(false);
    const [downloadingUserDateRange, setDownloadingUserDateRange] = useState(false);
    const [downloadingUserAllTrackings, setDownloadingUserAllTrackings] = useState(false);
    const onCloseDownloadUserDateRangeModal = () => {
        setShowDownloadUserDateRange(false);
        setDownloadUserFromDate('');
        setDownloadUserToDate('');
        setDownloadUserIncludeLabelType(false);
    };
    const onOpenDownloadUserDateRangeModal = () => setShowDownloadUserDateRange(true);
    const updateUrl = () => {
        const params = new URLSearchParams();

        if (search) params.set('search', search);
        if (filter !== 'All') params.set('status', filter);
        if (sort) params.set('sort', sort);
        if (page > 1) params.set('page', page.toString());
        if (limit !== 10) params.set('limit', limit.toString());

        setSearchParams(params);
    };
    const getUsers = async (search) => {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('limit', limit.toString());
        params.append('sort', sort);
        params.append('status', filter);

        if (search) params.append('search', search);
        const link = `/admin/users/read?${params.toString()}`;

        await api
            .get(link)
            .then((res) => {
                setUsers(res.data.users);
                setTotalPages(res.data.totalPages);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const enablePremiumPricing = async (id) => {
        await api
            .post('/admin/premium/' + id, {})
            .then((res) => {
                getUsers();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    const cancelPremiumPricing = async (id) => {
        await api
            .delete('/admin/premium_cancel/' + id)
            .then((res) => {
                getUsers();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    const DisableUser = async (id) => {
        await api
            .put('/admin/users/disable-user/' + id, {})
            .then((res) => {
                getUsers();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    const subBalance = async (e) => {
        e.preventDefault();
        setLoader(true);

        const data = {
            balance: e.target.balance.value,
        };

        await api
            .post('/admin/users/sub-balance/' + user._id, data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getUsers();
                onCloseRemoveBalanceModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });
    };

    const deleteUser = async (e) => {
        e.preventDefault();
        setLoader(true);

        const params = {
            id: user._id,
        };

        await api
            .delete(`/admin/users/delete/${params.id}`)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getUsers();
                onCloseDeleteuserModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });
    };

    // Sync URL params with state
    useEffect(() => {
        updateUrl();
    }, [filter, sort, page, limit, search]);

    // Fetch orders when URL params change
    useEffect(() => {
        getUsers();
    }, [searchParams]);

    const addBalance = async (e) => {
        e.preventDefault();

        const data = {
            balance: e.target.balance.value,
        };

        await api
            .post('/admin/users/add-balance/' + user._id, data)
            .then((res) => {
                setLoader(false);
                getUsers();
                toast.success(res.data.message);
                onCloseAddBalanceModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });
    };

    const addNewUser = async (e) => {
        e.preventDefault();

        const data = {
            email: e.target.email.value,
            username: e.target.username.value,
            password: e.target.password.value,
        };

        await api
            .post('/admin/users/create', data)
            .then((res) => {
                setLoader(false);
                getUsers();
                toast.success(res.data.message);
                onCloseUserAddModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });
    };

    // Enable Disable Custom Pricing
    const enableDisabledCustomPricing = async (id) => {
        await api
            .put('/admin/user/custom-pricing/enable/' + id, {})
            .then((res) => {
                getUsers();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    const downloadCsv = async (id) => {
        await api
            .get(`/admin/user/download-csv/${id}`, env.downloadConfig)
            .then((response) => {
                //  download zip file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'allLabelsTrackings.csv'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    // Download All Users Trackings with Date Range
    const downloadAllUsersTrackingDateRange = async (e) => {
        e.preventDefault();
        if (!downloadAllFromDate || !downloadAllToDate) {
            toast.error('Please select both from and to dates');
            return;
        }

        setDownloadingAllDateRange(true);
        const payload = {
            fromDate: downloadAllFromDate,
            toDate: downloadAllToDate,
            isLabelType: downloadAllIncludeLabelType,
        };

        await api
            .post('/admin/download-orders-by-date-range', payload, env.downloadConfig)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                const fileName = `${downloadAllFromDate}_${downloadAllToDate}_orders.csv`;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                toast.success('CSV downloaded successfully');
                onCloseDownloadAllTrackingsModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to download CSV');
            })
            .finally(() => {
                setDownloadingAllDateRange(false);
            });
    };

    // Download All Trackings Full
    const downloadAllTrackingsFull = async () => {
        setDownloadingAllTrackings(true);
        const payload = {
            isLabelType: downloadAllIncludeLabelType,
        };

        await api
            .post('/admin/download-orders-all-users', payload, env.downloadConfig)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'all_users_trackings.csv');
                document.body.appendChild(link);
                link.click();
                toast.success('CSV downloaded successfully');
                onCloseDownloadAllTrackingsModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to download CSV');
            })
            .finally(() => {
                setDownloadingAllTrackings(false);
            });
    };

    // Download User Tracking with Date Range
    const downloadUserTrackingDateRange = async (e) => {
        e.preventDefault();
        if (!downloadUserFromDate || !downloadUserToDate) {
            toast.error('Please select both from and to dates');
            return;
        }

        setDownloadingUserDateRange(true);
        const payload = {
            fromDate: downloadUserFromDate,
            toDate: downloadUserToDate,
            isLabelType: downloadUserIncludeLabelType,
        };

        await api
            .post(`/admin/user/download-orders-by-date-range/${user._id}`, payload, env.downloadConfig)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                const fileName = `${user.username}_${downloadUserFromDate}_${downloadUserToDate}_trackings.csv`;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                toast.success('CSV downloaded successfully');
                onCloseDownloadUserDateRangeModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to download CSV');
            })
            .finally(() => {
                setDownloadingUserDateRange(false);
            });
    };

    // Download All User Trackings
    const downloadAllUserTrackings = async () => {
        setDownloadingUserAllTrackings(true);
        const payload = {
            isLabelType: downloadUserIncludeLabelType,
        };

        await api
            .post(`/admin/user/download-orders-full/${user._id}`, payload, env.downloadConfig)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                const fileName = `${user.username}_all_trackings.csv`;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                toast.success('CSV downloaded successfully');
                onCloseDownloadUserDateRangeModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to download CSV');
            })
            .finally(() => {
                setDownloadingUserAllTrackings(false);
            });
    };
    return (
        <PageContainer
            title="Manage Users"
            desc=" All your registered users at one place"
            end={
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<DownloadIcon />}
                        onClick={() => onOpenDownloadAllTrackingsModal()}>
                        Download Users Tracking
                    </Button>
                    <Button variant="contained" onClick={() => onOpenUserAddModal()}>
                        Add User
                    </Button>
                </Box>
            }>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Field
                    placeholder="Search users using name, email address"
                    onChange={(e) => {
                        getUsers(e.target.value);
                    }}
                />
                <Select
                    size="small"
                    value={sort}
                    onChange={(e) => {
                        setSort(e.target.value);
                    }}>
                    <MenuItem value="asc">Ascending</MenuItem>
                    <MenuItem value="desc">Descending</MenuItem>
                </Select>
                <Select
                    size="small"
                    value={limit}
                    onChange={(e) => {
                        setLimit(e.target.value);
                    }}>
                    <MenuItem value="10">10</MenuItem>
                    <MenuItem value="20">20</MenuItem>
                    <MenuItem value="50">50</MenuItem>
                    <MenuItem value="100">100</MenuItem>
                </Select>
            </Box>
            <CustomTable
                sx={{ mt: 2 }}
                fields={['#', 'NAME', 'EMAIL', 'BALANCE', 'STATUS', 'JOINED', 'ACTION']}
                dense={false}
                loading={loader}
                pagination
                count={totalPages}
                page={page}
                setPage={setPage}>
                {users.map((user, index) => (
                    <TableRow key={index}>
                        <TableCell>{page > 1 ? (page - 1) * 10 + index + 1 : index + 1}</TableCell>
                        <TableCell>{user.username}</TableCell>
                        <TableCell>{user.email}</TableCell>
                        <TableCell
                            sx={{
                                color: 'success.main',
                            }}>
                            {'$' + (user.balance ? user.balance.toFixed(2) : '0.00')}
                        </TableCell>
                        <TableCell>
                            <StatusComp status={user.status ? 'active' : 'inactive'} />
                        </TableCell>
                        <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>

                        <TableCell>
                            <Stack direction="row">
                                <Tooltip title="User Details">
                                    <IconButton
                                        onClick={() => {
                                            setUser(user);
                                            onOpenUserModal();
                                        }}>
                                        <VisibilityOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Add Balance">
                                    <IconButton
                                        onClick={() => {
                                            setUser(user);
                                            onOpenAddBalanceModal();
                                        }}>
                                        <AttachMoneyOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Subtract Balance">
                                    <IconButton
                                        onClick={() => {
                                            setUser(user);
                                            onOpenRemoveBalanceModal();
                                        }}>
                                        <MoneyOffCsredOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>

                                {user.status ? (
                                    <Tooltip title="Disable User">
                                        <IconButton
                                            color="success"
                                            onClick={() => {
                                                DisableUser(user._id);
                                            }}>
                                            <PersonOffOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Enable User">
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                DisableUser(user._id);
                                            }}>
                                            <PersonOutlineOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Tooltip title="Delete User">
                                    <IconButton
                                        color="error"
                                        onClick={() => {
                                            setUser(user);
                                            onOpenDeleteuserModal();
                                        }}>
                                        <DeleteOutlineOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>

                                {user.premium ? (
                                    <Tooltip title="Cancel Premium">
                                        <IconButton
                                            color="success"
                                            onClick={() => {
                                                cancelPremiumPricing(user._id);
                                            }}>
                                            <LocalPoliceOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Enable Premium">
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                enablePremiumPricing(user._id);
                                            }}>
                                            <LocalPoliceOutlinedIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}

                                {user.customPricingEnabled ? (
                                    <Tooltip title="Disable Custom Pricing">
                                        <IconButton
                                            color="success"
                                            onClick={() => {
                                                enableDisabledCustomPricing(user._id);
                                            }}>
                                            <PriceChangeIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Enable Custom Pricing">
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                enableDisabledCustomPricing(user._id);
                                            }}>
                                            <PriceChangeIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                                {user.customPricingEnabled && (
                                    <Link to={'/customPricing/' + user._id}>
                                        <Tooltip title="Add Custom Pricing">
                                            <IconButton color="warning">
                                                <RequestQuoteIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Link>
                                )}
                                <Tooltip title="Download All Trackings">
                                    <IconButton
                                        color="info"
                                        onClick={() => {
                                            downloadCsv(user._id);
                                        }}>
                                        <ArticleIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Download Trackings by Date Range">
                                    <IconButton
                                        color="primary"
                                        onClick={() => {
                                            setUser(user);
                                            onOpenDownloadUserDateRangeModal();
                                        }}>
                                        <DateRangeIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
            {/* User Details */}
            <ModalContainer hideActions open={showUser} onClose={onCloseUserModal} title="User Details">
                <div className="text-start">
                    <p>
                        <strong className="text-muted"> ID :</strong> <span className="ms-2 h5">{user?._id}</span>
                    </p>
                    <p>
                        <strong className="text-muted">Username :</strong>{' '}
                        <span className="ms-2 h5 text-primary">{user?.username}</span>
                    </p>

                    <p>
                        <strong className="text-muted">Email :</strong> <span className="ms-2 h5">{user?.email}</span>
                    </p>

                    <p>
                        {user?.premium ? (
                            <>
                                <strong className="text-primary">Premium User :</strong>
                                <span className="ms-2 h5 text-primary">Yes</span>
                            </>
                        ) : (
                            <>
                                <strong className="text-muted">Premium User :</strong>
                                <span className="ms-2 h5">No</span>
                            </>
                        )}
                    </p>

                    <p>
                        <strong className="text-muted">Balance :</strong>
                        <span className="ms-2 text-primary h5">
                            {' '}
                            ${user?.balance ? user?.balance.toFixed(2) : '0.00'}{' '}
                        </span>
                    </p>
                    <p>
                        <strong className="text-muted text-20">Joined :</strong>
                        <span className="ms-2 h5"> {new Date(user?.createdAt).toDateString()} </span>
                    </p>
                </div>
            </ModalContainer>

            {/* Add Balance */}
            <ModalContainer hideActions open={showAddBalance} onClose={onCloseAddBalanceModal} title="Add Balance">
                <form onSubmit={addBalance} className="form-validate is-alter">
                    <div className="form-group">
                        <label className="form-label" htmlFor="full-name">
                            Balance
                        </label>

                        <input
                            type="text"
                            name="balance"
                            placeholder="Enter the amount to be added in user's balance"
                            className="form-control"
                        />
                    </div>

                    <div className="form-group mt-2 mb-2">
                        <Button variant="contained" type="submit">
                            Add
                        </Button>
                    </div>
                </form>
            </ModalContainer>

            {/* Remove Balance */}
            <ModalContainer
                hideActions
                open={showRemoveBalance}
                onClose={onCloseRemoveBalanceModal}
                title="Subtract Balance">
                <form onSubmit={subBalance} className="form-validate is-alter">
                    <div className="form-group">
                        <label className="form-label" htmlFor="full-name">
                            Balance
                        </label>

                        <input
                            type="text"
                            name="balance"
                            placeholder="Enter the amount to be added in user's balance"
                            className="form-control"
                        />
                    </div>

                    <div className="form-group mt-2 mb-2">
                        <button className="btn btn-lg btn-danger" type="submit">
                            Subtract {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* Delete User */}
            <ModalContainer hideActions open={showDeleteuser} onClose={onCloseDeleteuserModal} title="Delete User">
                <form onSubmit={deleteUser}>
                    <div className="form-group mb-3">
                        <p>Are you sure you want to delete this user?</p>
                    </div>

                    <div className="d-flex mt-2 justify-content-end ">
                        <Button type="button" onClick={onCloseDeleteuserModal}>
                            Close
                        </Button>
                        <Button type="submit" variant="contained" color="error">
                            Delete
                        </Button>
                    </div>
                </form>
            </ModalContainer>

            {/* Create User */}
            <ModalContainer hideActions open={addUser} onClose={onCloseUserAddModal} title="Add New User">
                <form onSubmit={addNewUser} className="form-validate is-alter">
                    <div className="form-group mb-2">
                        <label className="form-label" htmlFor="full-name">
                            Username
                        </label>

                        <input type="text" name="username" placeholder="Enter the username" className="form-control" />
                    </div>
                    <div className="form-group mb-2">
                        <label className="form-label" htmlFor="full-name">
                            Email
                        </label>

                        <input type="email" name="email" placeholder="Enter the email" className="form-control" />
                    </div>

                    <div className="form-group mb-2">
                        <label className="form-label" htmlFor="full-name">
                            Password
                        </label>

                        <input type="text" name="password" placeholder="Enter the password" className="form-control" />
                    </div>

                    <div className="form-group mt-2 mb-2">
                        <Button variant="contained" type="submit">
                            Add
                        </Button>
                    </div>
                </form>
            </ModalContainer>

            {/* Download All Users Tracking Modal */}
            <ModalContainer
                hideActions
                open={showDownloadAllTrackings}
                onClose={onCloseDownloadAllTrackingsModal}
                title="Download Users Tracking">
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {/* Section 1: Download with Date Range */}
                    <Box sx={{ borderBottom: '1px solid #e0e0e0', pb: 3 }}>
                        <Typography variant="h4" sx={{ color: '#fff', mb: 3 }}>
                            Download Trackings by Date Range
                        </Typography>
                        <form onSubmit={downloadAllUsersTrackingDateRange}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
                                    <TextField
                                        label="From Date"
                                        type="date"
                                        size="small"
                                        value={downloadAllFromDate}
                                        onChange={(e) => setDownloadAllFromDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                        sx={{ width: '100%' }}
                                    />
                                    <TextField
                                        label="To Date"
                                        type="date"
                                        size="small"
                                        value={downloadAllToDate}
                                        onChange={(e) => setDownloadAllToDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                        sx={{ width: '100%' }}
                                    />
                                </Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={downloadAllIncludeLabelType}
                                            onChange={(e) => setDownloadAllIncludeLabelType(e.target.checked)}
                                        />
                                    }
                                    label="Include Label Type Name"
                                />
                                <Button
                                    variant="contained"
                                    type="submit"
                                    startIcon={
                                        downloadingAllDateRange ? (
                                            <CircularProgress size={20} color="inherit" />
                                        ) : (
                                            <DownloadIcon />
                                        )
                                    }
                                    disabled={downloadingAllDateRange}>
                                    {downloadingAllDateRange ? 'Downloading...' : 'Download Date Range CSV'}
                                </Button>
                            </Box>
                        </form>
                    </Box>

                    {/* Section 2: Download All Trackings */}
                    <Box>
                        <Typography variant="h4" sx={{ color: '#fff', mb: 2 }}>
                            Download All Trackings
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={downloadAllIncludeLabelType}
                                        onChange={(e) => setDownloadAllIncludeLabelType(e.target.checked)}
                                    />
                                }
                                label="Include Label Type Name"
                            />
                            <Button
                                variant="contained"
                                color="success"
                                onClick={downloadAllTrackingsFull}
                                startIcon={
                                    downloadingAllTrackings ? (
                                        <CircularProgress size={20} color="inherit" />
                                    ) : (
                                        <DownloadIcon />
                                    )
                                }
                                disabled={downloadingAllTrackings}>
                                {downloadingAllTrackings ? 'Downloading...' : 'Download All Trackings CSV'}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </ModalContainer>

            {/* Download User Date Range Tracking Modal */}
            <ModalContainer
                hideActions
                open={showDownloadUserDateRange}
                onClose={onCloseDownloadUserDateRangeModal}
                title={`Download Trackings - ${user?.username}`}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {/* Section 1: Download with Date Range */}
                    <Box sx={{ borderBottom: '1px solid #e0e0e0', pb: 3 }}>
                        <Typography variant="h4" sx={{ color: '#fff', mb: 3 }}>
                            Download Trackings by Date Range
                        </Typography>
                        <form onSubmit={downloadUserTrackingDateRange}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
                                    <TextField
                                        label="From Date"
                                        type="date"
                                        size="small"
                                        value={downloadUserFromDate}
                                        onChange={(e) => setDownloadUserFromDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                        sx={{ width: '100%' }}
                                    />
                                    <TextField
                                        label="To Date"
                                        type="date"
                                        size="small"
                                        value={downloadUserToDate}
                                        onChange={(e) => setDownloadUserToDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                        sx={{ width: '100%' }}
                                    />
                                </Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={downloadUserIncludeLabelType}
                                            onChange={(e) => setDownloadUserIncludeLabelType(e.target.checked)}
                                        />
                                    }
                                    label="Include Label Type Name"
                                />
                                <Button
                                    variant="contained"
                                    type="submit"
                                    startIcon={
                                        downloadingUserDateRange ? (
                                            <CircularProgress size={20} color="inherit" />
                                        ) : (
                                            <DownloadIcon />
                                        )
                                    }
                                    disabled={downloadingUserDateRange}>
                                    {downloadingUserDateRange ? 'Downloading...' : 'Download Date Range CSV'}
                                </Button>
                            </Box>
                        </form>
                    </Box>

                    {/* Section 2: Download All User Trackings */}
                    <Box>
                        <Typography variant="h4" sx={{ color: '#fff', mb: 2 }}>
                            Download All Trackings
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={downloadUserIncludeLabelType}
                                        onChange={(e) => setDownloadUserIncludeLabelType(e.target.checked)}
                                    />
                                }
                                label="Include Label Type Name"
                            />
                            <Button
                                variant="contained"
                                color="success"
                                onClick={downloadAllUserTrackings}
                                startIcon={
                                    downloadingUserAllTrackings ? (
                                        <CircularProgress size={20} color="inherit" />
                                    ) : (
                                        <DownloadIcon />
                                    )
                                }
                                disabled={downloadingUserAllTrackings}>
                                {downloadingUserAllTrackings ? 'Downloading...' : 'Download All Trackings CSV'}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </ModalContainer>
        </PageContainer>
    );
};

export default Users;
